import { render, staticRenderFns } from "./LyndusPay.vue?vue&type=template&id=753d5d31"
import script from "./LyndusPay.vue?vue&type=script&lang=js"
export * from "./LyndusPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports